import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true })
class Authentication extends VuexModule {

    auth = {
        username: "",
        imageProfile: "",
        email: "",
        userFlag: "",
        userRoleId: "",
        userDeptId: "",
        userDeptCode: "",
        permission: [],
    } as any

    @Mutation
    public SET_AUTHINFO (auth: any): void {
        this.auth = {
            username: auth.username,
            imageProfile: auth.imageProfile,
            email: auth.email,
            userFlag: auth.userFlag,
            userRoleId: auth.userRoleId,
            userDeptId: auth.userDeptId,
            userDeptCode: auth.userDeptCode,
            permission: auth.permission,
        }
    }

    @Action
    AUTHINFO(auth: string) {
        this.context.commit("SET_AUTHINFO", auth)
    }

   
}

export default Authentication 